<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#E3F2FD"
                  d="M10.833 4.514L10.833 12.639 9.028 10.833 0 10.833 0 19.861 5.417 19.861 7.971 19.861 13.697 19.861 16.25 19.861 21.667 19.861 21.667 4.514z"
                  transform="translate(-1012 -255) translate(981 232) translate(24 16) translate(7 7) translate(2.167 3.25)"
                />
                <path fill="#13A2E8" d="M0 0L0 10.833 9.028 10.833 10.833 12.639 10.833 0z" transform="translate(-1012 -255) translate(981 232) translate(24 16) translate(7 7) translate(2.167 3.25)" />
                <path fill="#E3F2FD" d="M1.806 9.028L9.028 9.028 9.028 1.806 1.806 1.806z" transform="translate(-1012 -255) translate(981 232) translate(24 16) translate(7 7) translate(2.167 3.25)" />
                <g>
                  <path
                    fill="#13A2E8"
                    d="M15.347 8.666c-.499 0-.903-.404-.903-.902 0-.5.404-.903.903-.903s.903.404.903.903c0 .498-.404.902-.903.902m0-3.61c-1.496 0-2.708 1.212-2.708 2.708 0 1.495 1.212 2.708 2.708 2.708 1.496 0 2.709-1.213 2.709-2.708 0-1.496-1.213-2.709-2.709-2.709M7.58 2.077v-.003l-1.122.816.428 1.318c.03.092 0 .194-.082.253-.082.06-.189.056-.266 0l-1.121-.815-1.122.815c-.077.056-.185.06-.266.001-.082-.06-.112-.162-.081-.254l.427-1.318-1.12-.815v.002c-.057-.042-.095-.108-.095-.183 0-.125.102-.228.227-.228v-.001h1.386l.43-1.318c.028-.09.113-.157.214-.157.1 0 .186.066.214.157l.43 1.318h1.386c.124 0 .226.104.226.229 0 .075-.037.141-.094.183"
                    transform="translate(-1012 -255) translate(981 232) translate(24 16) translate(7 7) translate(2.167 3.25) translate(0 3.07)"
                  />
                  <path
                    fill="#164194"
                    d="M12.639 14.986c0-.996.809-1.806 1.805-1.806h1.806c.995 0 1.806.81 1.806 1.806h-5.417zm9.028-13.542h-9.028V3.25h7.222v11.736c0-1.994-1.617-3.611-3.611-3.611h-1.806c-1.994 0-3.61 1.617-3.61 3.611H1.805V9.569H0v7.223h21.667V1.444z"
                    transform="translate(-1012 -255) translate(981 232) translate(24 16) translate(7 7) translate(2.167 3.25) translate(0 3.07)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>